import { Typography } from "@/design-system/Atoms"; 

type TermsAndConditionLayoutProps = {
  heading?: string;
  content?: string | React.ReactNode;
  className?: string;
};

export const TermsAndConditionLayout = ({
  heading,
  content,
  className,
}: TermsAndConditionLayoutProps) => {
  return (
    <>
      <Typography variant="privacyPolicyTitle" as="div" className={`${className}`}>
        {heading}
      </Typography> 
      
      <Typography variant="privacyPolicyDescription" as="p">
        {content}
      </Typography> 
    </>
  );
};

export default TermsAndConditionLayout;
